import type { ReactNode } from 'react'
import { BRAND_NAME } from '../BrandLogo'
import { useT } from '@/i18n'

type VerlaufTheme = 'dark' | 'light'

interface VerlaufDialogProps {
  theme: VerlaufTheme
  onClose?: () => void
  children: ReactNode
  videoSlot: ReactNode
}

function CloseButton({ theme, onClick }: { theme: VerlaufTheme; onClick: () => void }) {
  const t = useT()
  return (
    <button
      className={`sg-dialog__close${theme === 'light' ? ' sg-dialog__close--light' : ''}`}
      aria-label={t.common.close}
      onClick={onClick}
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </button>
  )
}

export default function VerlaufDialog({ theme, onClose, children, videoSlot }: VerlaufDialogProps) {
  return (
    <div className={`sg-vdialog sg-vdialog--${theme}`}>
      <div className="sg-vdialog__content">
        {onClose && <CloseButton theme={theme} onClick={onClose} />}
        {children}
      </div>
      <div className="sg-vdialog__photo">
        {videoSlot}
        <div className={`sg-vdialog__fade sg-vdialog__fade--${theme}`} />
        <div className="sg-vdialog__brand-overlay">
          <img src="/logo-tscheppa-weiss.svg" alt="Tscheppaschlucht" className="sg-vdialog__brand-logo" />
          <span className="sg-vdialog__brand-text">{BRAND_NAME}</span>
        </div>
      </div>
    </div>
  )
}
